/**
 * @generated SignedSource<<cc22bb804c4bc9605b885a0ce7fa0974>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Page_Pool",
    "kind": "LinkedField",
    "name": "poolsByViewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Pool",
        "kind": "LinkedField",
        "name": "content",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardPan",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "confirmRecurringPoolsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "confirmRecurringPoolsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3eeea681f2695f89cd7864a77de92c01",
    "id": null,
    "metadata": {},
    "name": "confirmRecurringPoolsQuery",
    "operationKind": "query",
    "text": "query confirmRecurringPoolsQuery(\n  $request: PoolsRequestInput\n) {\n  poolsByViewer(request: $request) {\n    content {\n      id\n      cardPan\n      cardType\n    }\n  }\n}\n"
  }
};
})();

node.hash = "6098358217a6e5f9c26ca149114b6b78";

module.exports = node;
